// src/components/imagepicker/PreviewGrid.jsx
import React from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import ImageIcon from "@mui/icons-material/Image";
import PreviewCard from "./PreviewCard";
import styles from "./styles/styles.module.scss";

export default function PreviewGrid({
    value = [],
    thumbHeight = 260,
    toDisplaySrc,
    uploadingKeys = new Set(),
    onRemoveAt,
    onMakePrimary,
    emptyText = "���� �������� ���������",
}) {
    const list = Array.isArray(value) ? value : [];

    if (!list.length) {
        return (
            <Box className={styles.empty}>
                <ImageIcon className={styles.emptyIcon} sx={{ color: "#000" }} />
                <div className={styles.emptyText}>{emptyText}</div>
            </Box>
        );
    }

    return (
        <Grid container spacing={1.25} className={styles.grid}>
            {list.map((k, i) => {
                const key = String(k);
                const src = toDisplaySrc?.(key);
                const uploading = uploadingKeys.has(key);
                const isPrimary = i === 0;

                return (
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={key}>
                        <PreviewCard
                            src={src}
                            label={key}
                            thumbHeight={thumbHeight}
                            isPrimary={isPrimary}
                            uploading={uploading}
                            onRemove={() => onRemoveAt?.(i)}
                            onMakePrimary={() => onMakePrimary?.(i)}
                        />
                    </Grid>
                );
            })}
        </Grid>
    );
}